"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const screenConstants_1 = require("../../constants/screenConstants");
const ussdBankView_1 = __importDefault(require("../../components/loanPaymentMethods/ussdBank/ussdBankView"));
const bankTransferView_1 = __importDefault(require("../../components/loanPaymentMethods/bankTransfer/bankTransferView"));
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const store_1 = require("../../store");
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const input_1 = __importStar(require("../../components/input/input"));
const PaymentSummary = ({ route }) => {
    // TODO CHANGE THIS TO REDUX
    const { installment } = route.params;
    const navigation = (0, useAppNavigation_1.default)();
    const { bank, bankAccountNumber, ussdBanks } = (0, store_1.useAppSelector)((state) => {
        return {
            bank: state.home.collection_account ? state.home.collection_account.bank_name : '',
            bankAccountNumber: state.home.collection_account ? state.home.collection_account.bank_account_number : '',
            ussdBanks: state.home.active_loan.list_ussd_for_next_installment,
        };
    });
    const [paymentMethod, setPaymentMethod] = (0, react_1.useState)(ussdBanks.length > 0 ? 'USSD' : 'BANK_TRANSFER');
    let paymentMethodChoices = [];
    // change choices for payment options depending on user eligibility
    if (ussdBanks.length === 0) {
        paymentMethodChoices = [{ value: 'BANK_TRANSFER', label: 'Bank Transfer' }];
    }
    else {
        paymentMethodChoices = [
            { value: 'USSD', label: 'USSD' },
            { value: 'BANK_TRANSFER', label: 'Bank Transfer' },
        ];
    }
    return (react_1.default.createElement(navContainer_1.default, { isLoading: false, childrenTitle: "Payment summary" },
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Select a payment method", choices: paymentMethodChoices, value: paymentMethod || '', setValue: setPaymentMethod, error: null }),
        paymentMethod === 'USSD' && (react_1.default.createElement(ussdBankView_1.default, { installment: installment, ussdBankAccountList: ussdBanks || [] })),
        paymentMethod === 'BANK_TRANSFER' && (react_1.default.createElement(bankTransferView_1.default, { installment: installment, bankName: bank, bankAccountNumber: bankAccountNumber, onPress: () => navigation.navigate(screenConstants_1.HOME_SCREEN) }))));
};
exports.default = PaymentSummary;
